module.exports = __webpack_public_path__ + "media/images/mobile/document-a1c1fd7ea106d502963c124e7d637bbc.png";